import keyBy from 'lodash/keyBy';
import values from 'lodash/values';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { fetchPermissionGroups } from '../feedback-linking.utils';

export default {
    namespaced: true,
    state: {
        map: {},
        error: {},
        fetching: false,
    },
    mutations: {
        setMap (state, { map }) {
            state.map = map;
        },
        setError (state, { error }) {
            state.error = error;
        },
        setFetching (state, { fetching }) {
            state.fetching = fetching;
        },
    },
    actions: {
        loadAll ({ commit, state, rootState, rootGetters }, { reFetch = false } = {}) {
            if (
                !get(rootState, 'subscription.active.vendorId', false) ||
                !rootGetters['productLines/productLineByType']('feedback').purchased
            ) {
                return Promise.resolve();
            }
            if (!isEmpty(state.map) && !reFetch) {
                return Promise.resolve();
            }

            commit('setFetching', { fetching: true });

            return fetchPermissionGroups()
                .then(({ data: permissionGroups }) => {
                    commit('setFetching', { fetching: false });
                    commit('setMap', {
                        map: keyBy(permissionGroups, 'id'),
                    });
                })
                .catch((error) => {
                    commit('setFetching', { fetching: false });
                    commit('setError', { error });
                    throw error;
                });
        },
    },
    getters: {
        permissionGroupById: (state) => (id) => state.map[id],
        list: (state) => values(state.map),
        adminPermissionGroup: (state, getters) => {
            return getters.list.find((permissionGroup) => permissionGroup.name.toLowerCase() === 'administrator');
        },
        contributorPermissionGroup: (state, getters) => {
            return getters.list.find(
                (permissionGroup) => permissionGroup.name.toLowerCase() === 'feedback contributor',
            );
        },
    },
};
